import DOMPurify from 'dompurify';

// Strip anything DOMPurify can't prove safe: <script>, on* handlers,
// javascript: URIs, embeddable elements (<iframe>/<object>/<embed>),
// inline event handlers in SVG, etc. KB authors are trusted humans but
// articles render to authenticated client sessions on help.recore.su,
// so a compromised admin must not be able to harvest tokens.
//
// Keep classes/data-* — injectClipMarkers adds `<span class="kb-clip-marker"
// data-clip-idx data-clip-term>` AFTER sanitize.
export const sanitizeArticleHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p', 'br', 'hr',
      'strong', 'em', 'u', 's', 'b', 'i', 'mark', 'sub', 'sup', 'code', 'pre',
      'blockquote',
      'ul', 'ol', 'li',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'a',
      'img',
      'figure', 'figcaption',
      'span', 'div',
      'table', 'thead', 'tbody', 'tr', 'th', 'td',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'title', 'class', 'data-clip-idx', 'data-clip-term'],
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'svg', 'math', 'form', 'input', 'button'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'srcdoc', 'srcset', 'formaction'],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|tel:|\/|#)/i,
  });
